import type { ComponentProps } from "react";
import type { WithdrawalMetrics } from "../schema";

export interface WithdrawalDashboardProps
	extends Omit<ComponentProps<"section">, "children"> {
	data: WithdrawalMetrics;
	labels?: {
		total?: string;
		date?: string;
		email?: string;
		order?: string;
		items?: string;
		status?: string;
		empty?: string;
	};
	formatDate?: (isoDatetime: string) => string;
}

export const WithdrawalDashboard = ({
	data,
	labels,
	formatDate,
	...rest
}: WithdrawalDashboardProps) => {
	const format = formatDate ?? ((value: string) => value);

	return (
		<section data-withdrawal-dashboard {...rest}>
			<div data-withdrawal-stats>
				<div data-withdrawal-stat>
					<span data-withdrawal-stat-label>
						{labels?.total ?? "Total withdrawals"}
					</span>
					<span data-withdrawal-stat-value>{data.total}</span>
				</div>
			</div>

			{data.events.length === 0 ? (
				<p data-withdrawal-empty>{labels?.empty ?? "No withdrawals yet."}</p>
			) : (
				<table data-withdrawal-table>
					<thead>
						<tr>
							<th>{labels?.date ?? "Date"}</th>
							<th>{labels?.email ?? "Email"}</th>
							<th>{labels?.order ?? "Order"}</th>
							<th>{labels?.items ?? "Items"}</th>
							<th>{labels?.status ?? "Status"}</th>
						</tr>
					</thead>
					<tbody>
						{data.events.map((event, index) => (
							<tr
								key={`${event.orderNumber ?? "unknown"}-${event.datetime}-${index}`}
							>
								<td>{format(event.datetime)}</td>
								<td>{event.email ?? "—"}</td>
								<td>{event.orderNumber ?? "—"}</td>
								<td>
									{event.itemCount ??
										event.items.reduce(
											(total, item) => total + item.quantity,
											0,
										)}
								</td>
								<td>{event.status ?? "—"}</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</section>
	);
};
